import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Radio } from 'lucide-react';

// Compact news card used in the News grid.
const NewsCard = ({ article }) => (
  <Link to={`/news/${article.id}`} className="dctv-card rounded-2xl overflow-hidden group flex flex-col">
    <div className="h-44 overflow-hidden bg-[#0a0e16] flex items-center justify-center">
      {article.image ? (
        <img src={article.image} alt={article.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
      ) : (
        <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-[#e8743b]/15 to-[#0c1119]">
          <Radio className="w-10 h-10 text-[#e8743b]" />
        </div>
      )}
    </div>
    <div className="p-6 flex flex-col flex-1">
      <span className="dctv-eyebrow text-[#e8743b] text-[10px]">{article.theme}</span>
      <p className="text-[#6b7384] text-xs mt-1.5">{article.date} · {article.readTime}</p>
      <h3 className="font-serif-dctv text-[18px] font-semibold text-white mt-2 leading-snug group-hover:text-[#f4965a] transition-colors">{article.title}</h3>
      <p className="text-[#9aa3b2] text-[13px] leading-relaxed mt-2">{article.excerpt}</p>
      <div className="flex items-center gap-2 mt-auto pt-4 border-t border-white/8">
        <img src={article.author.avatar} alt={article.author.name} className="w-7 h-7 rounded-full object-cover object-top border border-white/10" />
        <span className="text-[#9aa3b2] text-xs flex-1">{article.author.name}</span>
        <ArrowUpRight className="w-4 h-4 text-[#e8743b]" />
      </div>
    </div>
  </Link>
);

export default NewsCard;
